import { useParams } from "react-router-dom";
import { DualStakeIndex } from "./page-index";
import { DualStakePage } from "./page-single";

export function DualStake() {
  const { token } = useParams();

  if (!token) {
    return (
        <DualStakeIndex  />
    );
  }

  if (token) {
    return (
        <DualStakePage />
    );
  }
}